import { BASE_WEB_URL, Routes } from '../constants/routes';
export var HREF_TARGETS;
(function (HREF_TARGETS) {
    HREF_TARGETS["BLANK"] = "_blank";
    HREF_TARGETS["SELF"] = "_self";
    HREF_TARGETS["PARENT"] = "_parent";
    HREF_TARGETS["TOP"] = "_top";
})(HREF_TARGETS || (HREF_TARGETS = {}));
export var MENU_LOCATIONS;
(function (MENU_LOCATIONS) {
    MENU_LOCATIONS["HEADER"] = "HEADER";
    MENU_LOCATIONS["MOBILE_HEADER"] = "MOBILE_HEADER";
})(MENU_LOCATIONS || (MENU_LOCATIONS = {}));
export const menuConfig = [
    {
        uid: 1,
        title: 'Race',
        href: '/race',
        disabled: true,
        menuLocations: [MENU_LOCATIONS.HEADER, MENU_LOCATIONS.MOBILE_HEADER],
        menuItems: [
            {
                uid: 1,
                title: 'Upcoming events',
                href: Routes.UPCOMING_EVENTS,
                disabled: false,
                menuLocations: [MENU_LOCATIONS.MOBILE_HEADER]
            },
            {
                uid: 2,
                title: 'Results',
                href: Routes.RESULTS,
                disabled: false,
                menuLocations: [MENU_LOCATIONS.MOBILE_HEADER]
            },
            {
                uid: 3,
                title: 'Winnings',
                href: Routes.WINNINGS,
                disabled: false,
                menuLocations: [MENU_LOCATIONS.MOBILE_HEADER]
            },
            {
                uid: 4,
                title: 'Leaderboards',
                href: Routes.LEADERBOARDS,
                disabled: true,
                menuLocations: [MENU_LOCATIONS.MOBILE_HEADER]
            }
        ]
    },
    {
        uid: 2,
        title: 'Stables',
        href: Routes.STABLES,
        menuLocations: [MENU_LOCATIONS.HEADER, MENU_LOCATIONS.MOBILE_HEADER],
        menuItems: [
            {
                uid: 1,
                title: 'Race stable',
                href: Routes.STABLES,
                menuLocations: [MENU_LOCATIONS.HEADER, MENU_LOCATIONS.MOBILE_HEADER]
            },
            {
                uid: 2,
                title: 'Breeding stable',
                disabled: true,
                href: Routes.BREEDING,
                menuLocations: [MENU_LOCATIONS.HEADER, MENU_LOCATIONS.MOBILE_HEADER]
            }
        ]
    },
    {
        uid: 3,
        title: 'Social',
        href: Routes.SOCIAL,
        disabled: false,
        menuLocations: [MENU_LOCATIONS.HEADER, MENU_LOCATIONS.MOBILE_HEADER],
        menuItems: [
            {
                uid: 1,
                title: 'Friends',
                href: Routes.FRIENDS,
                disabled: false,
                menuLocations: [MENU_LOCATIONS.MOBILE_HEADER]
            },
            {
                uid: 2,
                title: 'My guild',
                href: Routes.MY_GUILD,
                disabled: true,
                menuLocations: [MENU_LOCATIONS.MOBILE_HEADER]
            },
            {
                uid: 3,
                title: 'All guilds',
                href: Routes.ALL_GUILD,
                disabled: true,
                menuLocations: [MENU_LOCATIONS.MOBILE_HEADER]
            }
        ]
    },
    {
        uid: 4,
        title: 'News',
        href: `${BASE_WEB_URL}${Routes.NEWS}`,
        menuLocations: [MENU_LOCATIONS.HEADER, MENU_LOCATIONS.MOBILE_HEADER],
        isExternal: true,
        menuItems: [
            {
                uid: 1,
                title: 'News',
                href: `${BASE_WEB_URL}${Routes.NEWS}`,
                isExternal: true,
                menuLocations: [MENU_LOCATIONS.HEADER, MENU_LOCATIONS.MOBILE_HEADER]
            },
            {
                uid: 2,
                title: 'Updates',
                href: `${BASE_WEB_URL}${Routes.NEWS}`,
                isExternal: true,
                menuLocations: [MENU_LOCATIONS.HEADER, MENU_LOCATIONS.MOBILE_HEADER]
            }
        ]
    },
    {
        uid: 5,
        title: 'FAQ',
        href: `${BASE_WEB_URL}${Routes.FAQ}`,
        isExternal: true,
        menuLocations: [MENU_LOCATIONS.HEADER, MENU_LOCATIONS.MOBILE_HEADER]
    },
    {
        uid: 6,
        title: 'WHITEPAPER',
        href: `${BASE_WEB_URL}${Routes.WHITEPAPER}`,
        isExternal: true,
        menuLocations: [MENU_LOCATIONS.HEADER, MENU_LOCATIONS.MOBILE_HEADER]
    }
];
